
const defaultState = {
    qhseConformityLoading: false,
    cookingDelaysLoading: false,
    reproductionNeedsLoading: false,
    qhseConformityPSEs: [],
    reloadedQhseConformityPSEs: [],
    cookingDelaysPSEs: [],
    reloadedCookingDelaysPSEs: [],
    reproductionNeeds: [],
    reloadedReproductionNeedsPSEs: [],
    cookingDelaysNotificationCount: 0,
}

export default (state = defaultState, action) =>{
    switch (action.type) {
        case "QHSE_CONFORMITY_LOADING":
            return {
                ...state,
                qhseConformityLoading: action.loading,
            }
        case "COOKING_DELAYS_LOADING":
            return {
                ...state,
                cookingDelaysLoading: action.loading,
            }
        case "REPRODUCTION_NEEDS_LOADING":
            return {
                ...state,
                reproductionNeedsLoading: action.loading,
            }
        case "QHSE_PSES_LOADED":
            return {
                ...state,
                qhseConformityPSEs: action.productionStepExecutions,
            }
        case "QHSE_PSES_RELOADED":
            return {
                ...state,
                reloadedQhseConformityPSEs: action.productionStepExecutions,
            }
        case "COOKING_DELAYS_PSES_LOADED":
            return {
                ...state,
                cookingDelaysPSEs: action.productionStepExecutions,
            }
        case "COOKING_DELAYS_PSES_RELOADED":
            return {
                ...state,
                reloadedCookingDelaysPSEs: action.productionStepExecutions,
                cookingDelaysNotificationCount: action.cookingDelaysNotificationCount
            }
        case "REPRODUCTION_NEEDS_PSES_LOADED":
            return {
                ...state,
                reproductionNeeds: action.productionStepExecutions,
            }
        case "REPRODUCTION_NEEDS_PSES_RELOADED":
            return {
                ...state,
                reloadedReproductionNeedsPSEs: action.productionStepExecutions,
            }
        case "UPDATE_REPROD_NEED": {
            const reprodNeeds = state.reproductionNeeds || []
            const needIndex = reprodNeeds.findIndex(reprodNeed => reprodNeed.objectId === action.objectId)
            if (needIndex === -1) return state

            const updatedReprodNeeds = [...reprodNeeds]
            updatedReprodNeeds[needIndex] = { 
                ...updatedReprodNeeds[needIndex], 
                reproductionStatus: action.status,
                reproductionNetWeight: action.netWeight
            }

            return { ...state, reproductionNeeds: updatedReprodNeeds }
        }
        default:
            return {
                ...state
            }
    }
}

export const getAlertsLoadingSelector = state =>
    state.alerts.qhseConformityLoading || state.alerts.cookingDelaysLoading || state.alerts.reproductionNeedsLoading

// ------------ QHSE conformity ------------ //
export const getQHSEConformityLoadingSelector = state => state.alerts.qhseConformityLoading

export const getQHSEConformityPSEsSelector = state => state.alerts.qhseConformityPSEs || []

export const getQHSEConformityReloadedPSEsSelector = state => state.alerts.reloadedQhseConformityPSEs || []

// ------------ Cooking delays ------------ //
export const getCookingDelaysLoadingSelector = state => state.alerts.cookingDelaysLoading

export const getCookingDelaysPSEsSelector = state => state.alerts.cookingDelaysPSEs || []

export const getCookingDelaysReloadedPSEsSelector = state => state.alerts.reloadedCookingDelaysPSEs || []

export const getCookingDelaysNotificationCountSelector = state => state.alerts.cookingDelaysNotificationCount || 0

// --------- Reproduction needs ---------- //
export const getReproductionNeedsLoadingSelector = state => state.alerts.reproductionNeedsLoading

export const getReproductionNeedsSelector = state => state.alerts.reproductionNeeds || []

export const getReproductionNeedsReloadedSelector = state => state.alerts.reloadedReproductionNeedsPSEs || []
